import { createSlice } from '@reduxjs/toolkit';
import { ExceptionReportResponseType } from '../../components/ExceptionReport/ExceptionReport.types';
import { revertAll } from './userReducer';


const exceptionReportsInitialState: ExceptionReportResponseType = {
	dailyReport: {},
	weeklyReport: {},
};

const exceptioReportsReducer = createSlice({
	name: 'exceptionReports',
	initialState: exceptionReportsInitialState,
	reducers: {
		setExceptionReports: (state, action) => {

			state = action.payload;

			return state;
		}
	},
	extraReducers(builder) {
		builder
			.addCase(revertAll, () => exceptionReportsInitialState);
	},
});

export const { setExceptionReports } = exceptioReportsReducer.actions;

export default exceptioReportsReducer;
